import { render, staticRenderFns } from "./input-widget.vue?vue&type=template&id=770aaf34&scoped=true"
import script from "./input-widget.vue?vue&type=script&lang=js"
export * from "./input-widget.vue?vue&type=script&lang=js"
import style0 from "./input-widget.vue?vue&type=style&index=0&id=770aaf34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770aaf34",
  null
  
)

export default component.exports